import React from 'react'
import { ContainerTitle } from './BrandingsElements'
function Title(data) {
  return (
      <ContainerTitle>{data.data}</ContainerTitle>
  )
}

export default Title